import { supabase } from './supabase'

export const getCurrentUserId = async (): Promise<string | null> => {
  try {
    // Prefer cached session user first to avoid an extra network round trip on app boot.
    const { data: { session }, error: sessionError } = await supabase.auth.getSession()
    if (sessionError) {
      console.error('Error getting current session:', sessionError)
    }
    if (session?.user?.id) {
      return session.user.id
    }

    const { data: { user }, error } = await supabase.auth.getUser()
    if (error) {
      console.error('Error getting current user:', error)

      // Check if the error is due to a deleted user (stale JWT)
      if (error.message?.includes('User from sub claim in JWT does not exist')) {
        console.log('Detected deleted user, clearing session...')
        await supabase.auth.signOut()
      }

      return null
    }
    return user?.id || null
  } catch (error) {
    console.error('Error in getCurrentUserId:', error)
    return null
  }
}

export const requireAuth = async (): Promise<string> => {
  const userId = await getCurrentUserId()
  if (!userId) {
    throw new Error('User not authenticated')
  }

  return userId
}
